/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */
  import PRM from "@/core/PermissionConstants";

 export default {
   path: "/app/dental/pendientes",
   name: "DENTAL_ATTEND",
   component: () => import("@/app/views/DentalView.vue"),
   meta: {
     service: () => import("@/app/services/DentalConsultationService"),
     table: () => import("@/app/components/dental/pending/DentalAppointmentPendingTable.vue"),
     form: () => import("@/app/components/dental/pending/DentalAppointmentPendingForm.vue"),
     pdfModal: () => import("@/app/components/dental/pending/DentalAppointmentModalConfirm.vue"),
     header: {
       icono: "mdi-tooth",
       texto: "Consultas pendientes | Dental",
       textNew: "Atender consulta | Dental",
       textEdit: "Editar consulta | Dental",
     },
     prm: PRM.MODULE_DENTAL_BEGIN,
     requireAuth: true,
     filterDate: true,
     hideButtonAdd: true,
     filterModality: true,
     cancelationModal: true,
     generatePDFModal: true,
     saveButton: "Finalizar Consulta",
     typeofTable: "consultation",
     labelDate: "Seleccione fecha"
   },
 };
 